import { CSSObject } from "@emotion/react";
import {
  type AnchorStyleOverrides,
  type ButtonStyleOverrides,
  constants,
} from "@newsela/angelou";

export const accountOptionsContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: "0 0.5rem",
  gap: "0.5rem",
};

export const accountOptionsTitleCss: CSSObject = {
  lineHeight: "1.5rem",
  fontWeight: 700,
  padding: "0 0.5rem",
  color: constants.colors.ui.neutral[700],
  margin: 0,
};

export const accountOptionsUnorderedListCss: CSSObject = {
  margin: 0,
  padding: 0,
  width: "100%",
  listStyleType: "none",
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",

  li: {
    textAlign: "left",
    color: constants.colors.ui.neutral[700],
  },
};

export const accountOptionButtonCss: ButtonStyleOverrides<CSSObject> = {
  root: {
    width: "100%",
    padding: "0.25rem 0.5rem",
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem",

    ":hover": {
      background: "#F1F7FF",
    },

    svg: {
      width: "1.5rem",
      height: "1.5rem",

      path: {
        fill: constants.colors.ui.neutral[700],
      },
    },
  },
};

export const accountOptionAnchorCss: AnchorStyleOverrides<CSSObject> = {
  root: {
    width: "100%",
    padding: "0.25rem 0.5rem",
    textDecoration: "none",
    borderRadius: "0.5rem",

    "> div": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "0.5rem",
      color: constants.colors.ui.neutral[700],
    },

    ":hover": {
      background: "#F1F7FF",
    },

    svg: {
      width: "1.5rem",
      height: "1.5rem",

      path: {
        fill: constants.colors.ui.neutral[700],
      },
    },
  },
};
